import React, { useRef, useState } from 'react';
import { IconButton, Popover, Typography, Paper, MenuList, MenuItem } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import { getApi } from 'api/axios';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
const ExportCSV = () => {
  const [anchorElement, setAnchorElement] = useState(null);
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  const linkRef = useRef();
  const handleGetCSV = async ({ isCSV }) => {
    try {
      const options = isCSV
        ? {
            headers: {
              Accept: 'application/csv',
              'Content-Type': 'application/csv'
            },
            responseType: 'blob'
          }
        : {
            headers: {
              Accept: 'application/pdf',
              'Content-Type': 'application/pdf'
            },
            responseType: 'blob'
          };
      const res = await (
        await getApi({ baseUrl: window._env_.REACT_APP_QDAK_ORDER_URL })
      ).get(
        `/admin/shops/${shopId}/orders/order-items/accounting/export${
          localStorage.getItem('reportorders')
            ? localStorage.getItem('reportorders') + '&size=100000&page=1'
            : '?size=100000&page=1'
        }`,
        options
      );

      const fileType = isCSV ? 'application/csv; charset=UTF-8' : 'application/pdf';
      const href = window.URL.createObjectURL(new Blob([res.data], { type: fileType }));

      const a = linkRef.current;
      a.download =
        t('chartQueryBuilder.exportCSV.reportList') +
        ' ' +
        new Date().toLocaleDateString('hu-HU') +
        ' ' +
        (isCSV ? '.csv' : '.pdf');
      a.href = href;
      a.click();
      a.href = '';
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <a ref={linkRef} />
      <IconButton onClick={handleClick} sx={{ color: 'black' }}>
        <FileDownloadIcon />
      </IconButton>

      <Popover
        open={Boolean(anchorElement)}
        anchorEl={anchorElement}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}>
        <Paper sx={{ p: 1, minWidth: 150 }}>
          <Typography variant='subtitle1' sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
            {t('chartQueryBuilder.exportCSV.export')}
          </Typography>
          <MenuList>
            <MenuItem
              onClick={() => {
                handleGetCSV({ isCSV: true });
                handleClose();
              }}>
              <TableChartIcon sx={{ mr: 1 }} />
              {t('chartQueryBuilder.exportCSV.exportCSV')}
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleGetCSV({ isCSV: false });
                handleClose();
              }}>
              <PictureAsPdfIcon sx={{ mr: 1 }} />
              {t('chartQueryBuilder.exportCSV.exportPDF')}
            </MenuItem>
          </MenuList>
        </Paper>
      </Popover>
    </div>
  );
};

export default ExportCSV;
